import { CaretDownOutlined, CaretUpOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { secondsToHms } from '../common/Common';

const IQ3KouteiBetsuKesanshiki_Program = (props) => {
  return (
    <div className="kouteiCalculateDiv" id="kouteiCalculateDivID">
      <Row style={{ width: '100%', borderBottom: '1px solid #eee', cursor: 'pointer' }}>
        <Col span={4} style={{ paddingLeft: 40, paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取金額'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工金額'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'要素数'}</label>
          </div>
        </Col>
        <Col span={12} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'基本段取時間'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'段取時間(秒) x 段取時間チャージ/3600(秒)'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'1要素当たりの作業時間ｘ要素数ｘ作業時間係数'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'加工時間(秒) x 加工時間チャージ/3600(秒)'}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{'要素数'}</label>
          </div>
        </Col>
        <Col span={8} style={{ paddingTop: 10 }}>
          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${props?.dandoriTimeSec} (${secondsToHms(props?.dandoriTimeSec)})`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${props?.dandoriTimeSec} × ${props?.mSetHRate}) ÷ 3600 = ${props?.dandoriAmt}`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>
              {`${props?.workBasicTime} × ${props?.dataItems_elementCnt} × ${props?.workTimeElementCoeff} = ${
                props?.cSagyoTimeSec
              } (${secondsToHms(props?.cSagyoTimeSec)})`}
            </label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`(${props?.cSagyoTimeSec} × ${props?.mWorkHRate}) ÷ 3600 = ${props?.cSagyoAmt}`}</label>
          </div>

          <div
            style={{
              borderBottom: '2px solid #eeebeb',
              paddingBottom: 4,
            }}
          >
            <label>{`${props?.dataItems_elementCnt}`}</label>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default IQ3KouteiBetsuKesanshiki_Program;
